<template>
  <div id="app">
    <div class="navbar is-light">
      <div class="navbar-brand">
        <span
          v-if="auth && auth.userProfile && auth.userProfile.name"
          class="username navbar-item">{{ auth.userProfile.name }}</span>
      </div>
      <div class="navbar-menu is-active">
        <div class="navbar-end">
          <div class="navbar-item">
            <a
              v-if="loggedIn"
              href="#"
              class="button is-info"
              @click.prevent="logout">Logout</a>
            <a
              v-else
              href="#"
              class="button is-info"
              @click.prevent="login">Log In</a>
          </div>
        </div>
      </div>
    </div>
    <router-view class="container"/>
  </div>
</template>

<script>
import auth from '@/services/AuthService'

export default {
  name: 'app',
  data () {
    return {
      auth,
      loggedIn: false
    }
  },
  mounted () {
    this.loggedIn = this.auth.getAuthenticatedFlag()
    this.auth.authNotifier.on('authChange', data => this.setAuthState(data))
    if (this.loggedIn) {
      this.auth.renewSession()
    }
  },
  methods: {
    logout () {
      auth.logout()
    },
    login () {
      this.auth.login()
    },
    setAuthState (state) {
      if (state && state.authenticated) {
        this.loggedIn = true
        this.checkUserInfo()
      } else {
        this.loggedIn = false
      }
    },
    checkUserInfo () {
      if (!this.loggedIn) { return }
      if (!this.auth.userProfile) {
        this.auth.getUserInfo().then(() => {
          this.$forceUpdate()
        })
      }
    }
  }
}
</script>

<style lang="scss">
#app .container {
  margin-top: 20px;
}
</style>
